<template>
  <div id="contenedor-default-licitacion">
    <v-skeleton-loader v-if="$apollo.loading" type="card"></v-skeleton-loader>
    <v-card v-else flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                NÚMERO DE LICITACIÓN:
              </span>
            </div>
            <div>
              <span>{{ getLicitacion.numero }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                TIPO:
              </span>
            </div>
            <div>
              <span>
                {{
                  getLicitacion.tipo === 1
                    ? "LICITACIÓN PÚBLICA"
                    : "LICITACIÓN RESTINGIDA POR INVITACIÓN"
                }}
              </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                CARACTER:
              </span>
            </div>
            <div>
              <span>{{ getLicitacion.caracter === 1 ? "NACIONAL" : "" }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                NORMATIVIDAD:
              </span>
            </div>
            <div>
              <span>{{
                getLicitacion.normatividad === 1 ? "FEDERAL" : "ESTATAL"
              }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                OBJETO:
              </span>
            </div>
            <div>
              <span> {{ getLicitacion.objeto }} </span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                NÚMERO DE CONVOCATORIA:
              </span>
            </div>
            <div>
              <span> {{ getLicitacion.numeroConvocatoria }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                FECHA DE CONVOCATORIA:
              </span>
            </div>
            <div>
              <span> {{ formatoFecha(getLicitacion.fechaConvocatoria) }} </span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                FECHA DE INICIO:
              </span>
            </div>
            <div>
              <span> {{ formatoFecha(getLicitacion.fechaInicio) }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                FECHA DE TERMINO:
              </span>
            </div>
            <div>
              <span> {{ formatoFecha(getLicitacion.fechaTermino) }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                PLAZO:
              </span>
            </div>
            <div>
              <span> {{ getLicitacion.plazo }} dias </span>
            </div>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                ANTICIPO DE MATERIAL:
              </span>
            </div>
            <div>
              <span> {{ getLicitacion.anticipoMaterial }} % </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                ANTICIPO DE INICIO:
              </span>
            </div>
            <div>
              <span> {{ getLicitacion.anticipoInicio }} % </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                TOTAL DE ANTICIPO:
              </span>
            </div>
            <div>
              <span>
                {{
                  getLicitacion.anticipoInicio + getLicitacion.anticipoMaterial
                }}
                %
              </span>
            </div>
          </v-col>
        </v-row>
        <div>
          <v-divider></v-divider>
          <v-row class="mt-4">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                OBRAS:
              </span>
            </div>
          </v-row>
          <v-data-table
          v-if="getLicitacion.obras.length > 0"
          :headers="headers"
          :items="getLicitacion.obras"
          disable-pagination
          disable-filtering
          hide-default-footer>
          <template v-slot:[`item.obra.tipo`]="{ item }">
            <v-chip :color="item.obra.tipo.color">
              <span>
                {{item.obra.tipo.descripcion}}
              </span>
            </v-chip>
          </template>
          </v-data-table>
          <span v-else>Esta licitación no tiene obras registradas.</span>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import LICITACION from '@/graphql/querys/administracion/licitaciones/licitacion.gql';
// import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'Defaultlicitacion',
  components: {
    // FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Clave',
          class: 'secondary--text font-weight-bold',
          align: 'start',
          value: 'obra.clave',
          width: '115',
          sortable: false,
        },
        {
          text: 'Tipo', class: 'secondary--text font-weight-bold', value: 'obra.tipo.descripcion', sortable: false,
        },
        {
          text: 'Meta', class: 'secondary--text font-weight-bold', value: 'obra.meta', sortable: false,
        },
      ],
    };
  },
  apollo: {
    licitacion: {
      query: LICITACION,
      variables() {
        return {
          id: this.$route.params.idLicitacion,
        };
      },
    },
  },
  methods: {
    formatoFecha(fecha) {
      if (!fecha) return null;
      const [year, month, day] = fecha.split('-');
      return `${month}/${day}/${year}`;
    },
  },
  computed: {
    getLicitacion() {
      if (!this.licitacion) return {};
      return this.licitacion;
    },

  },
};
</script>

<style lang="scss">
</style>
